import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DialogComponent, DialogModule, TooltipModule } from '@syncfusion/ej2-angular-popups';
import { BrandLogosService } from '../brand-logos.service';
import { SwitchComponent, SwitchModule } from '@syncfusion/ej2-angular-buttons';
import { DeleteBrandLogoDTO } from 'src/app/base/models/models.swagger.generated';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'app-brand-logos-delete-dialog',
    templateUrl: './brand-logos-delete-dialog.component.html',
    styleUrls: ['./brand-logos-delete-dialog.component.scss'],
    imports: [DialogModule, SwitchModule, TooltipModule, TranslateModule]
})
export class BrandLogosDeleteDialogComponent {

  @ViewChild("editProductAssetDialog")
  public dialog: DialogComponent;

  @ViewChild("deleteAllProductLogosSwitch")
  public deleteAllProductLogosSwitch: SwitchComponent;

  @ViewChild("reapplyProductLogosSwitch")
  public reapplyProductLogosSwitch: SwitchComponent;

  @Output()
  public OnClose: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  public isBrandLogo: boolean = false;

  public isLoading = false;
  private id: number;
  public deleteAllProductLogos: boolean = false;
  public reapplyProductLogos: boolean = false;

  constructor(
    private brandLogosService: BrandLogosService
  ) {}

  public showDeleteDialog(id: number) {
    this.id = id;
    this.dialog.show();
  }

  public onCancel() {
    if(this.isLoading) {
      return;
    }
    this.dialog.hide();
    this.resetDialog();
  }

  public onOpen(args: any): void {
    //Preventing the default dialog focus
    args.preventFocus = true;
  }

  public onDelete() {
    if(this.isLoading) {
      return;
    }
    var dto = new DeleteBrandLogoDTO({
      id: this.id,
      deleteAllProductLogos: this.deleteAllProductLogos,
      reapplyProductLogos: this.reapplyProductLogos,
    });
    this.isLoading = true;
    this.brandLogosService.deleteBrandLogo(dto).subscribe({
      next: () => {
        this.isLoading = false;
        this.OnClose.emit();
        this.dialog.hide();
        this.resetDialog();
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  public deleteAllProductLogosSwitched() {
    this.deleteAllProductLogos = this.deleteAllProductLogosSwitch.checked;
    if (!this.deleteAllProductLogos) {
      this.reapplyProductLogos = false;
      this.reapplyProductLogosSwitch.checked = false;
    }
  }

  public reapplyProductLogosSwitched() {
    this.reapplyProductLogos = this.reapplyProductLogosSwitch.checked;
    this.deleteAllProductLogos = true;
    this.deleteAllProductLogosSwitch.checked = true;
  }

  private resetDialog() {
    this.isLoading = false;
    this.id = null;
    this.deleteAllProductLogos = false;
    this.reapplyProductLogos = false;
    this.deleteAllProductLogosSwitch.checked = false;
    this.reapplyProductLogosSwitch.checked = false;
  }

}
